import React from "react";
import { useCase } from "../../../contexts/CaseContext";
import { useSupervisor } from "../../../contexts/SupervisorContext";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../design/dropdown";
import { useVisit } from "../../../contexts/VisitContext";

const Toolbar: React.FC = (props) => {
  const { filter, setFilter } = useVisit();
  const { cases } = useCase();
  const { supervisors } = useSupervisor();

  const caseItem = cases.find((c) => c.id === filter?.caseId);
  const supervisor = supervisors.find((s) => s.id === filter?.supervisorId);

  return (
    <div className="flex gap-2">
      <Dropdown>
        <DropdownButton outline>
          {caseItem ? `Case ID: ${caseItem.identifier}` : "Filter by case"}
        </DropdownButton>
        <DropdownMenu>
          {caseItem && (
            <DropdownItem
              onClick={() =>
                setFilter({
                  caseId: undefined,
                  supervisorId: filter?.supervisorId,
                })
              }
            >
              Clear selection
            </DropdownItem>
          )}
          {cases
          .filter((caseItem) => caseItem.status !== "closed")
          .map((caseItem) => (
            <DropdownItem
              key={caseItem.id}
              onClick={() =>
                setFilter({
                  caseId: caseItem.id,
                  supervisorId: filter?.supervisorId,
                })
              }
            >
              {`${caseItem.identifier ?? "Unnamed Case"} - (${Object.values(
                caseItem.parents ?? {},
              )
                .map((p) => `${p.firstName} ${p.lastName}`)
                .join(", ")})`}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
      <Dropdown>
        <DropdownButton outline>
          {supervisor
            ? `Supervisor: ${supervisor.firstName} ${supervisor.lastName}`
            : "Filter by supervisor"}
        </DropdownButton>
        <DropdownMenu>
          {supervisor && (
            <DropdownItem
              onClick={() =>
                setFilter({
                  caseId: filter?.caseId,
                  supervisorId: undefined,
                })
              }
            >
              Clear selection
            </DropdownItem>
          )}
          {supervisors
            .filter((s) => s.status !== "inactive")
            .map((supervisor) => (
              <DropdownItem
                key={supervisor.id}
                onClick={() =>
                  setFilter({
                    caseId: filter?.caseId,
                    supervisorId: supervisor.id,
                  })
                }
              >
                {supervisor.firstName} {supervisor.lastName}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default Toolbar;
